import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useAuth0 } from 'app/Auth'
import { CircularProgress } from '@mui/material'
import styles from './ProductEmailService.module.scss'

const ProductEmailService: React.FC = () => {
  const productEmailServiceUrl =
    process.env.REACT_APP_PRODUCT_EMAIL_SERVICE_URL ||
    'https://email-service-qa.medgeo.com'
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const { getAccessToken } = useAuth0()
  const [isLoading, setIsLoading] = useState(true)
  const [iframeKey] = useState(0)
  const [iframeLoaded, setIframeLoaded] = useState(false)

  const sendTokenToIframe = useCallback(async () => {
    try {
      const token = await getAccessToken()
      if (
        iframeRef.current &&
        iframeRef.current.contentWindow &&
        iframeLoaded
      ) {
        iframeRef.current.contentWindow.postMessage(
          { type: 'SET_TOKEN', token },
          productEmailServiceUrl
        )
      }
    } catch (error) {
      console.error('Error getting access token:', error)
    }
  }, [getAccessToken, iframeLoaded, productEmailServiceUrl])

  const handleIframeLoad = () => {
    setIframeLoaded(true)
    setIsLoading(false)
    sendTokenToIframe()
  }

  useEffect(() => {
    if (iframeLoaded) {
      sendTokenToIframe()
    }
  }, [iframeLoaded, sendTokenToIframe])

  return (
    <div className={styles.container}>
      {isLoading && (
        <div className={styles.loading}>
          <CircularProgress />
        </div>
      )}
      <iframe
        key={iframeKey}
        ref={iframeRef}
        src={productEmailServiceUrl}
        title="Product Email Service Dashboard"
        className={styles.iframe}
        sandbox="allow-scripts allow-same-origin allow-downloads allow-popups"
        onLoad={handleIframeLoad}
      />
    </div>
  )
}

export default ProductEmailService
